// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import {useStore} from '@nanostores/react';
import etask from '/util/etask.js';
import {User} from '@pub/comp/user';
import {Text} from '@pub/comp/text';
import {Button} from '@pub/comp/button';
import {alert} from '@pub/comp/alert';
import {$referral, link} from '@pub/store/referral.js';
import {mimic_by_query} from '@pub/utils/user.js';
import * as cns from './referral.module.less';

function Empty(){
    const handle_link = useCallback(()=>etask(function*(){
        const email = prompt('Email of user to link to');
        if (!email)
            return;
        try {
            yield link(email);
            alert({text: 'Successfully linked', positive: true});
        } catch(e){
            alert({text: 'Failed to link', negative: true});
        }
    }), []);
    return <div className={cns.empty}>
      <Text.s mono bold>Not found</Text.s>
      <Button size="xs" color_scheme="accent" view="link" ico="link"
        on_click={handle_link}>
        Link to someone
      </Button>
    </div>;
}

function User_card({value, selectable}){
    const handle_select = useCallback(()=>
        mimic_by_query(value.email), [value.email]);
    return <div className={cns.card}>
      <User user={value} no_bg/>
      <Text.xs secondary mono>
        email: {value.email}
      </Text.xs>
      {!!value._id&&<Text.xs secondary mono>
        id: {value._id}
      </Text.xs>}
      {selectable&&<Button view="link" color_scheme="accent" size="xs"
        on_click={handle_select}>
        Select
      </Button>}
    </div>;
}

function Node({title, user, is_current}){
    return <div className={cns.node}>
      <Text.xs>{title}</Text.xs>
      {user
        ? <User_card value={user} selectable={!is_current}/>
        : <Empty/>
      }
    </div>;
}

export function Referral({user}){
    const ref = useStore($referral);
    return <div className={cns.root}>
      <div className={cns.tree}>
        <Node user={ref} title="Referral"/>
        <div className={cns.separator}/>
        <Node user={user} title="Referee" is_current/>
      </div>
    </div>;
}
